export const isButtonDisabled = false;
export const correctNetworkId = 137;
export const comingSoon = true;
